import { ActionFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import { CalendarState } from '../../controller';
import { CalendarContext } from '../../../../utils/context/contextFactory';
import { RefetchPlatformData } from '../refetchPlatformData/refetchPlatformData';
import { FilterTypes } from '../../ViewModel/filterViewModel/filterViewModel';
import { TriggeredByOptions } from '../../../../types/types';
import { isBookFlowSettingsEnabled } from '@wix/bookings-calendar-catalog-viewer-mapper';
import { initializeSelectedVariantsOptions } from '../../../../utils/initializeSelectedVariantsOptions/initializeSelectedVariantsOptions';

export type OnFilterChanged = (
  filter: Partial<Record<FilterTypes, string[]>> | undefined,
) => Promise<void>;

export function createOnFilterChanged(
  {
    getControllerState,
    context,
  }: ActionFactoryParams<CalendarState, CalendarContext>,
  refetchPlatformData: RefetchPlatformData,
): OnFilterChanged {
  return (filter: Parameters<OnFilterChanged>[0]) => {
    const [state, setState] = getControllerState();
    const { experiments, bookingsSettings, calendarSelections } = context;
    const { servicesInView, serviceVariantsMap } = state;

    const isBookFlowSettings = isBookFlowSettingsEnabled({
      experiments,
      bookingsSettings,
    });

    const selectedVariantsOptions = isBookFlowSettings
      ? initializeSelectedVariantsOptions({
          calendarSelections,
          servicesInView,
          serviceVariantsMap,
        })
      : [];

    setState({
      filterOptions: filter
        ? {
            ...state.filterOptions,
            ...filter,
          }
        : {
            [FilterTypes.SERVICE]: [],
            [FilterTypes.LOCATION]: [],
            [FilterTypes.STAFF_MEMBER]: [],
          },
      selectedVariantsOptions,
    });

    return refetchPlatformData(TriggeredByOptions.FILTER_CHANGED);
  };
}
